module.exports = __webpack_public_path__ + "img/ENI.c15dd387.png";